const isDevelopment = process.env.NODE_ENV === 'development';

type LogLevel = 'log' | 'error' | 'warn' | 'debug' | 'verbose';

class Logger {
    private formatMessage(level: LogLevel, message: string, context?: string): string {
        const contextStr = context ? `[${context}]` : '';
        return `[${level.toUpperCase()}] ${contextStr} ${message}`;
    }

    log(message: string, ...args: any[]): void;
    log(message: string, context?: string, ...args: any[]): void;
    log(message: string, contextOrArgs?: string | any[], ...args: any[]): void {
        const context = typeof contextOrArgs === 'string' ? contextOrArgs : undefined;
        const restArgs = typeof contextOrArgs === 'string' ? args : (contextOrArgs ? [contextOrArgs, ...args] : args);
        console.log(this.formatMessage('log', message, context), ...restArgs);
    }

    error(message: string, ...args: any[]): void;
    error(message: string, context?: string, ...args: any[]): void;
    error(message: string, contextOrArgs?: string | any[], ...args: any[]): void {
        const context = typeof contextOrArgs === 'string' ? contextOrArgs : undefined;
        const restArgs = typeof contextOrArgs === 'string' ? args : (contextOrArgs ? [contextOrArgs, ...args] : args);
        // Error logs are always shown
        console.error(this.formatMessage('error', message, context), ...restArgs);
    }

    warn(message: string, ...args: any[]): void;
    warn(message: string, context?: string, ...args: any[]): void;
    warn(message: string, contextOrArgs?: string | any[], ...args: any[]): void {
        const context = typeof contextOrArgs === 'string' ? contextOrArgs : undefined;
        const restArgs = typeof contextOrArgs === 'string' ? args : (contextOrArgs ? [contextOrArgs, ...args] : args);
        if (isDevelopment) {
            console.warn(this.formatMessage('warn', message, context), ...restArgs);
        }
    }

    debug(message: string, ...args: any[]): void;
    debug(message: string, context?: string, ...args: any[]): void;
    debug(message: string, contextOrArgs?: string | any[], ...args: any[]): void {
        const context = typeof contextOrArgs === 'string' ? contextOrArgs : undefined;
        const restArgs = typeof contextOrArgs === 'string' ? args : (contextOrArgs ? [contextOrArgs, ...args] : args);
        if (isDevelopment) {
            console.debug(this.formatMessage('debug', message, context), ...restArgs);
        }
    }

    verbose(message: string, ...args: any[]): void;
    verbose(message: string, context?: string, ...args: any[]): void;
    verbose(message: string, contextOrArgs?: string | any[], ...args: any[]): void {
        const context = typeof contextOrArgs === 'string' ? contextOrArgs : undefined;
        const restArgs = typeof contextOrArgs === 'string' ? args : (contextOrArgs ? [contextOrArgs, ...args] : args);
        if (isDevelopment) {
            console.debug(this.formatMessage('verbose', message, context), ...restArgs);
        }
    }
}

export const logger = new Logger();

